var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('section', {
    staticClass: "how-it-works-section",
    style: _vm.style
  }, [_c('Container', [_vm.sectionLayout === 'progress' ? _c('div', {
    staticClass: "progress-content-wrap flex items-center sm-md:flex-col"
  }, [_c('div', {
    staticClass: "progress-text-wrap"
  }, [_c('div', {
    staticClass: "progress-header"
  }, [_vm._v(_vm._s(_vm.header))]), _vm._v(" "), _c('ul', {
    staticClass: "progress-steps"
  }, _vm._l(_vm.steps, function (step, index) {
    return _c('li', {
      key: step._key,
      staticClass: "stepper"
    }, [_c('div', {
      staticClass: "flex items-center xl:flex-col xl:items-start lg:flex-col lg:items-start"
    }, [_c('div', {
      staticClass: "stepper-head"
    }, [_c('span', {
      staticClass: "stepper-head__icon"
    }, [_vm._v(_vm._s(index + 1))])]), _vm._v(" "), _c('sanity-block-content', {
      staticClass: "stepper-head__text",
      attrs: {
        "blocks": step.body
      }
    })], 1)]);
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "progress-image-wrap"
  }, [_vm.image.asset._ref ? _c('img', {
    attrs: {
      "src": _vm.urlFor(_vm.image).fit('max').auto('format').url(),
      "alt": _vm.image.alt ? _vm.image.alt : '',
      "loading": "lazy"
    }
  }) : _vm._e()])]) : _vm._e()]), _vm._v(" "), _vm.showBgImg ? _c('background-image', {
    attrs: {
      "image": _vm.styles.backgroundImage
    }
  }) : _vm._e()], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };